import ContainerWithArrowsBg from './ContainerWithArrowsBg'

export default ContainerWithArrowsBg
